import * as React from "react";
const PrintIcon = (props) => (
    <svg
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M4.833 4.667h6.334V3.334c0-1.333-.5-2-2-2H6.833c-1.5 0-2 .667-2 2zm5.834 5.334v2.666q0 2-2 2H7.333q-2 0-2-2v-2.666z"
            stroke="#008c95"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M11.333 10H4.667m0-2.667h2M14 6.666v3.333q0 2-2 2h-1.333v-2H5.333v2H4q-2 0-2-2V6.666q0-2 2-2h8q2 0 2 2"
            stroke="#008c95"
            strokeWidth={1.5}
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
export default PrintIcon;
